import ImageKit from "imagekit-javascript";
import { BASE_PATH } from "../constants";

const imagekit = new ImageKit({
  urlEndpoint: "https://ik.imagekit.io/elysiumone",
  publicKey: "public_lxZGS71ZHxIolHx1LTmIfukDqJU=",
  authenticationEndpoint: BASE_PATH + "/api/external/imagekit-signature",
});

export async function uploadOneImageToImageKit(file, fileName) {
  return new Promise((resolve, reject) => {
    imagekit.upload(
      {
        file, // required
        fileName, // required
      },
      function (error, result) {
        if (error || !result || !result.fileId || !result.url) {
          reject(error);
        } else {
          const reference = {
            fileId: result.fileId,
            fileName: result.name,
            fileUrl: result.url,
          };
          resolve(reference);
        }
      }
    );
  });
}

export default {
  uploadOneImageToImageKit,
};
